export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10069.733b64db.jpg";